import { Link } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BodyTextSmall } from "~/components/Typographies";

interface DidYouMeanLinkProps {
	onSelect: (suggestion: string) => void;
	suggestion: string;
}

const DidYouMeanLink = ({ onSelect, suggestion }: DidYouMeanLinkProps) => {
	const { t } = useTranslation("common");

	return (
		<BodyTextSmall component="div" sx={{ color: "text.secondary" }}>
			{t("search.didYouMean")}{" "}
			<Link
				component="button"
				onClick={() => onSelect(suggestion)}
				sx={{ fontWeight: 600, verticalAlign: "baseline" }}
				type="button"
				underline="hover"
			>
				{suggestion}
			</Link>
		</BodyTextSmall>
	);
};

export default DidYouMeanLink;
